const cssChannelFirstKey = 'tj-channel-'

/**
 * 获取渠道值
 */
export function getChannelByTheme() {
  if (document.body.classList.contains(`${cssChannelFirstKey}elong`)) {
    return 'elong';
  } else if (document.body.classList.contains(`${cssChannelFirstKey}qunar`)) {
    return 'qunar';
  } else if (document.body.classList.contains(`${cssChannelFirstKey}ctrip`)) {
    return 'ctrip';
  } else if (document.body.classList.contains(`${cssChannelFirstKey}mayi`)) {
    return 'mayi';
  } else {
    return 'tujia';
  }
}
/**
 * 设置渠道
 * @param {}} channel 
 */
export function setChannelTheme(channel){
  document.body.classList.add(`${cssChannelFirstKey}${channel}`)
}

export default {
  setChannelTheme,
  getChannelByTheme
}